<template>
  <section
    id="admin-device-add"
    style="z-index: 9;"
  >

    <b-card style="background-color: #fff0;">

      <validation-observer ref="loginValidation">
        <form-wizard
          color="rgb(43, 92, 108)"
          shape="tab"
          step-size="sm"
          :title="null"
          :subtitle="null"
          layout="horizontal"
          next-button-text="بعدی »"
          finish-button-text="تائید ✓"
          back-button-text="« قبلی"
          class="wizard-vertical mb-0"
          style="margin: 0 auto;"
        >
          <!-- @on-change="beforeTabSwitch" -->
          <!-- account datails tab -->
          <tab-content
            title="1"
            icon="mdi mdi-plus"
            :before-change="onChangeImei"
          >
            <b-row>
              <b-col
                cols="12"
                class="mb-0 pb-0"
              >
                <h5 class="mb-0">
                  ثبت دستگاه جدید
                </h5>
                <small class="text-muted">
                  شماره سریال 15 رقمی که بر روی پشت جعبه دستگاه درج شده را وارد کنید.
                </small>
              </b-col>
              <b-col md="12">
                <b-col
                  md="6"
                  class="p-0"
                >
                  <b-form-group
                    label="IMEI"
                    label-for="v-IMEI"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="IMEI"
                      rules="required"
                    >
                      <b-form-input
                        id="v-IMEI"
                        v-model="device.imei"
                        name="IMEI"
                        :state="errors.length > 0 ? false : null"
                        placeholder="IMEI"
                        class="numeric-input"
                        maxlength="15"
                        @keyup="imeiChangeEn($event)"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-col>

            </b-row>
          </tab-content>

          <!-- personal info tab -->
          <tab-content
            title="2"
            icon="mdi mdi-sim"
            :before-change="onSimConfigureStatus"
          >
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  شماره سیم کارت
                </h5>
                <small class="text-muted">شماره سیم کارت داخل دستگاه ردیاب را وارد کنید.</small>
              </b-col>
              <b-col
                md="12"
                class="p-0"
              >
                <b-col
                  md="6"
                  class="p-0"
                >
                  <b-form-group
                    label=""
                    label-for="v-Sim"
                    class="numeric-input"
                  >
                    <b-form-input
                      id="v-Sim"
                      v-model="device.sim"
                      name="Sim"
                      placeholder="شماره موبایل درون دستگاه را وارد کنید"
                      :disabled="simTimerSeconds !== -1"
                      maxlength="11"
                      @keyup="simChangeEn($event)"
                    />
                    <span
                      v-if="simTimerSeconds !== -1"
                      id="simTimerSeconds"
                    >
                      (لطفا صبر کنید...{{ simTimerSeconds }})
                    </span>

                  </b-form-group>
                </b-col>
              </b-col>
            </b-row>
          </tab-content>

          <!-- address -->
          <tab-content
            title="3"
            icon="mdi mdi-layers"
            :before-change="onConfirm"
          >
            <b-row>
              <b-col
                cols="12"
                class="mb-0"
              >
                <h5 class="mb-0">
                  دستگاه ردیاب شما با موفقیت تنظیم شد. جهت افزودن به سیستم اطلاعات بعدی را کامل کنید.
                </h5>
              </b-col>
              <b-col
                md="6"
                class="mb-0"
              >
                <b-form-group
                  label="عنوان"
                  label-for="v-title"
                >
                  <b-form-input
                    id="v-title"
                    v-model="device.title"
                    name="title"
                    placeholder="خودرو..."
                  />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="نوع وسیله نقلیه"
                  label-for="v-address"
                >
                  <b-form-select
                    v-model="selectedCategory"
                    :options="options"
                    :select-size="6"
                  />
                </b-form-group>
              </b-col>

            </b-row>
          </tab-content>
          <div
            v-if="loadingWizard"
            class="loader"
          />
        </form-wizard>
      </validation-observer>

    </b-card>
  </section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import {
  BFormSelect,
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Vue from 'vue'
import Device from '@/models/device'
// eslint-disable-next-line import/no-named-as-default
import DeviceService from '@/services/device.service'
import BreadcrumbMobile from '@/layouts/breadcrumb.vue'

import { functions } from '@/functions'
import Config from '../../../config'

Vue.prototype.$functions = functions

export default {
  components: {
    BreadcrumbMobile,
    BFormSelect,
    FormWizard,
    TabContent,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
  },
  data() {
    return {
      loadingWizard: false,
      device: new Device('', '', '', '', '', '', '', '', '', ''),
      count: 0,
      selectedCategory: '0',
      options: Config.carTypes,
      simTimerSeconds: -1,
      simStatus: false,
      simTimerPointer: null,
    }
  },
  methods: {
    onChangeImei() {
      return new Promise((resolve, reject) => {
        this.$refs.loginValidation.validate()
          .then(async success => {
            if (success) {
              if (this.device.imei) {
                await DeviceService.check({ imei: this.device.imei })
                  .then(
                    res => {
                      if (res.status === 'error') {
                        this.$toast({
                          component: ToastificationContent,
                          props: {
                            title: 'خطای بررسی imei',
                            text: res.message,
                            icon: 'XIcon',
                            variant: 'danger',
                          },
                        })
                        reject(res.message)
                      } else {
                        this.device = res.result.data
                        resolve(true)
                        // console.log(this.device)
                      }
                    }, error => {
                      this.message = (error.response && error.response.data)
                                || error.message
                                || error.toString()
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'خطای بررسی imei',
                          text: this.message,
                          icon: 'XIcon',
                          variant: 'danger',
                        },
                      })
                      reject(new Error('error'))
                    },
                  )
              } else {
                reject(new Error('error'))
              }
            }
          })
      })
    },
    onSimConfigureStatus() {
      if (!this.simStatus) {
        this.onConfigure()
        /*
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطای تنظیم سیمکارت',
            text: 'سیمکارت بررسی و تنظیم نشده است.',
            icon: 'XIcon',
            variant: 'danger',
          },
        })
        */
        return false
      }
      return true
    },
    onConfigure() {
      return new Promise((resolve, reject) => {
        this.$refs.loginValidation.validate()
          .then(async success => {
            if (success) {
              if (this.device.imei && this.device.sim) {
                DeviceService.configure(this.device)
                  .then(
                    res => {
                      if (res.status === 'error') {
                        this.$toast({
                          component: ToastificationContent,
                          props: {
                            title: 'خطای تنظیم سیمکارت',
                            text: res.message,
                            icon: 'XIcon',
                            variant: 'danger',
                          },
                        })
                        reject(res.message)
                      } else {
                        const seconds = 30
                        this.simTimerSeconds = seconds
                        this.simTimerPointer = setInterval(async () => {
                          if (this.simTimerSeconds % 5 === 0) {
                            DeviceService.configureStatus(this.device)
                              .then(
                                resp => {
                                  if (resp.status === 'error') {
                                    reject(res.message)
                                  } else {
                                    this.simStatus = true
                                    resolve(true)
                                    this.simTimerSeconds = -1
                                    clearInterval(this.simTimerPointer)

                                    this.$toast({
                                      component: ToastificationContent,
                                      props: {
                                        title: 'دستگاه با موفقیت تنظیم شد.',
                                        icon: 'EditIcon',
                                        variant: 'success',
                                      },
                                    })
                                  }
                                },
                              )
                          }
                          if (this.simTimerSeconds > 0) {
                            this.simTimerSeconds -= 1
                          } else if (!this.simStatus) {
                            this.simTimerSeconds = -1
                            clearInterval(this.simTimerPointer)
                            this.$toast({
                              component: ToastificationContent,
                              props: {
                                title: 'دستگاه تنظیم نشد مجدد امتحان کنید.',
                                text: res.message,
                                icon: 'XIcon',
                                variant: 'danger',
                              },
                            })
                          }
                        }, 1000)
                        resolve(true)
                      }
                    },
                  ).catch(error => {
                    this.message = (error.response && error.response.data)
                        || error.message
                        || error.toString()
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'خطای پاسخ سیمکارت',
                        text: this.message,
                        icon: 'XIcon',
                        variant: 'danger',
                      },
                    })
                    reject(this.message)
                  })
              }
            }
          })
      })
    },
    onConfirm() {
      return new Promise((resolve, reject) => {
        this.$refs.loginValidation.validate()
          .then(success => {
            if (success) {
              this.device.category = this.selectedCategory
              if (this.device.imei && this.device.sim && this.device.title) {
                DeviceService.confirm(this.device)
                  .then(
                    res => {
                      if (res.status === 'error') {
                        this.$toast({
                          component: ToastificationContent,
                          props: {
                            title: 'خطای تایید',
                            text: res.message,
                            icon: 'XIcon',
                            variant: 'danger',
                          },
                        })
                        reject(res.message)
                      } else {
                        resolve(true)
                        this.$toast({
                          component: ToastificationContent,
                          props: {
                            title: 'دستگاه با موفقیت اضافه شد.',
                            icon: 'EditIcon',
                            variant: 'success',
                          },
                        })

                        this.$router.push('/device/list')
                      }
                    },
                  ).catch(error => {
                    this.message = (error.response && error.response.data)
                        || error.message
                        || error.toString()
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'خطای تایید',
                        text: this.message,
                        icon: 'XIcon',
                        variant: 'danger',
                      },
                    })
                    reject(this.message)
                  })
              }
            }
          })
      })
    },
    onCancel() {
      this.show = false
      this.$router.push({ name: 'device-list' })
    },
    imeiChangeEn(event) {
      this.device.imei = this.$functions.fixNumbers(event.target.value)
    },
    simChangeEn(event) {
      this.device.sim = this.$functions.fixNumbers(event.target.value)
    },
  },
}
</script>
<style>
.wizard-nav-pills{
  border-right: 1px solid rgba(34,41,47,.08);
  padding-right: 2.5rem;
}
.wizard-card-footer{
  padding-top: 0px !important;
}
/* This is a css loader. It's not related to vue-form-wizard */
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(255, 255, 255, 0.2);
  border-right: 1.1em solid rgba(255, 255, 255, 0.2);
  border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
  border-left: 1.1em solid #e74c3c;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.wizard-card-footer{
  margin-top: 40px;
}
#admin-device-add{
  background-color: #5b5a5a;
}
@media (min-width: 768px) {
  #admin-device-add{
    background-color: rgb(255, 251, 251) !important;
    width: 800px;
    margin: 0 auto;
  }
}
</style>
